<script setup>
defineProps({
    dismissible: { type: Boolean, default: true },
});

const emit = defineEmits(['dismiss']);
</script>

<template>
    <div
        class="flex items-start gap-2 px-3 py-2 mb-2 text-xs border rounded-lg border-wlPrimary/20 bg-wlPrimary/5"
    >
        <svg
            class="flex-shrink-0 w-4 h-4 mt-0.5 text-wlPrimary"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path
                d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"
            />
        </svg>
        <div class="min-w-0">
            <p class="font-medium text-gray-800 !mb-0">
                {{ _mft('dashboard:flowie.handoff.label') }}
            </p>
            <p class="text-gray-600 !mb-0">
                {{ _mft('dashboard:flowie.handoff.description') }}
            </p>
        </div>
        <button
            v-if="dismissible"
            type="button"
            class="flex-shrink-0 ml-auto text-gray-400 hover:text-gray-600"
            @click="emit('dismiss')"
        >
            {{ _mft('dashboard:flowie.handoff.dismiss') }}
        </button>
    </div>
</template>
